import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import { namespace } from './namespace';
import { CREATOR_BASE_URL } from '../../../../utils/configure-environment';

const FONT = 'font';
const FONT_IMAGE = 'fontImage';
const FONT_LIST_BY_PRINTSTYLE = 'fontListByPrintStyle';
const EFFECT = 'effect';
const EFFECT_LIST_BY_PRINTSTYLE = 'effectListByPrintStyle';

export default {
  [FONT]: state => fontId => state.fonts[fontId] ? state.fonts[fontId] : null,
  [FONT_IMAGE]: state => fontId =>
    state.fonts[fontId] ? CREATOR_BASE_URL + state.fonts[fontId].image : null,
  [FONT_LIST_BY_PRINTSTYLE]: state => printStyle =>
    sortBy(
      filter(state.fonts, font => font.capabilities.includes(printStyle)),
      ['position']
    ),
  [EFFECT]: state => effectId =>
    state.effects[effectId] ? state.effects[effectId] : null,
  [EFFECT_LIST_BY_PRINTSTYLE]: state => printStyle =>
    filter(state.effects, effect => effect.capabilities.includes(printStyle))
};

export const GETTER_FONT_FONT = `${namespace}${FONT}`;
export const GETTER_FONT_IMAGE = `${namespace}${FONT_IMAGE}`;
export const GETTER_FONT_LIST_BY_PRINTSTYLE = `${namespace}${FONT_LIST_BY_PRINTSTYLE}`;
export const GETTER_FONT_EFFECT = `${namespace}${EFFECT}`;
export const GETTER_FONT_EFFECT_LIST_BY_PRINTSTYLE = `${namespace}${EFFECT_LIST_BY_PRINTSTYLE}`;
